const { Component, Utils, DOMUtils } = window.Liftoff;
Component.register(
  "image",
  class Image extends Component {
    constructor(config) {
      super(config);

      Utils.assignWithDefaults(
        this,
        {
          image: null,
          size: null,
          hpos: null,
          vpos: null,
          width: "100%",
          height: "100%",
          style: null,
          animation: null,
          popDurationMS: 500,
          popIterations: 1,
          animateInMethod: null,
          animateInDurationMS: 500,
          animateInDelayMS: 0,
        },
        this.config
      );
      this.image = this.image || null;

      // NOTE(brian): Temporary correction for switchover from background-size to
      // object-fit.
      if (this.size === "100% 100%") {
        this.size = "fill";
      }
    }

    load() {
      return this.isEmpty() ? Promise.resolve() : Utils.loadImage(this.image);
    }

    isEmpty() {
      return !this.image;
    }

    layout(parentNode) {
      super.layout(parentNode);

      this.el = document.createElement("img");
      this.el.classList.add("image-component");
      this.render();
      this.parentNode.appendChild(this.el);

      if (this.animateInMethod) {
        this.el.classList.add(`animation-${this.animateInMethod}`);
        DOMUtils.forceReflow(this.el);
        this.el.style.transitionDuration = `${this.animateInDurationMS}ms`;
        this.el.style.transitionDelay = `${this.animateInDelayMS}ms`;
      }

      this.addEventListeners();
    }

    addEventListeners() {
      this.on("set image", ({ image }) => {
        if (image === "") return;

        this.image = image;
        this.render();
      });

      this.on("animateIn", () => {
        if (this.animateInMethod != null) {
          this.el.classList.add("animate-in");
          if (this.animation != null) {
            DOMUtils.addOneTimeListener(this.el, "transitionend", () =>
              this._startRepeatingAnimation()
            );
          }
        }
      });
    }

    resize() {}

    start() {
      if (this.animateInMethod == null && this.animation != null) {
        this._startRepeatingAnimation();
      }
    }

    stop() {
      if (this.animation != null) {
        this.el.classList.remove(this.animation);
      }
    }

    restart() {
      this.stop();
      DOMUtils.forceReflow(this.el);
      this.start();
    }

    render() {
      if (this.image == null) return;

      const styleUpdates = {
        objectPosition: `${this.hpos} ${this.vpos}`,
        objectFit: this.size,
        width: this.width,
        ...this.style,
      };

      const heightUpdate = this._useHeightFix()
        ? {
            minHeight: this.height,
            maxHeight: this.height,
          }
        : {
            height: this.height,
          };

      Object.assign(this.el.style, styleUpdates, heightUpdate);
      this.el.src = this.image;
    }

    // CPL-568 Due to some Safari-only behavior related to the `height: 100%` tag,
    // we replace percent-based heights with min/max, as long as there aren't
    // conflicting styles elsewhere.
    _useHeightFix() {
      let useHeightFix = this.height && this.height.indexOf("%") > 0;
      if (this.style) {
        Object.keys(this.style).forEach((key) => {
          // If any user-supplied styles are height-related, then we'll return 'false'
          useHeightFix =
            useHeightFix && key.toLowerCase().indexOf("height") < 0;
        });
      }
      return useHeightFix;
    }

    _startRepeatingAnimation() {
      if (this.animation == null) return;

      Object.assign(this.el.style, { animationDelay: "0" });
      if (["pop", "blur-and-spin", "colorize"].includes(this.animation)) {
        Object.assign(this.el.style, {
          animationDuration: `${this.popDurationMS}ms`,
          animationIterationCount: `${this.popIterations}`,
        });
      }

      this.el.classList.add(this.animation);
    }
  }
);



// WEBPACK FOOTER //
// ./components/image/image.js